(function () {
  if (window.EvryNowTrendingSlider) return;

  var DESKTOP_QUERY = '(min-width: 991px)';

  function initNowTrendingSlider(root) {
    if (!root) return;

    var viewport = root.querySelector('[data-fpg-viewport]');
    var track = root.querySelector('[data-fpg-track]');
    var prevButton = root.querySelector('[data-fpg-prev]');
    var nextButton = root.querySelector('[data-fpg-next]');
    var cards = root.querySelectorAll('[data-fpg-card]');

    if (!viewport || !cards.length) return;

    if (root._ntsScrollHandler) {
      viewport.removeEventListener('scroll', root._ntsScrollHandler);
      root._ntsScrollHandler = null;
    }

    if (prevButton && prevButton._ntsClickHandler) {
      prevButton.removeEventListener('click', prevButton._ntsClickHandler);
    }

    if (nextButton && nextButton._ntsClickHandler) {
      nextButton.removeEventListener('click', nextButton._ntsClickHandler);
    }

    function isDesktop() {
      return window.matchMedia(DESKTOP_QUERY).matches;
    }

    function getScrollStep() {
      var firstCard = cards[0];
      if (!firstCard) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      return firstCard.getBoundingClientRect().width + gap;
    }

    function getMaxScroll() {
      return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    }

    function updateArrows() {
      if (!prevButton || !nextButton) return;
      if (!isDesktop()) {
        prevButton.disabled = true;
        nextButton.disabled = true;
        return;
      }

      var maxScroll = getMaxScroll();
      prevButton.disabled = viewport.scrollLeft <= 1;
      nextButton.disabled = viewport.scrollLeft >= maxScroll - 1;
    }

    function scrollByCard(direction) {
      if (!isDesktop()) return;

      var step = getScrollStep();
      if (!step) return;

      var maxScroll = getMaxScroll();
      var target = viewport.scrollLeft + direction * step;
      target = Math.max(0, Math.min(target, maxScroll));

      viewport.scrollTo({
        left: target,
        behavior: 'smooth',
      });
    }

    if (prevButton) {
      prevButton._ntsClickHandler = function () {
        scrollByCard(-1);
      };
      prevButton.addEventListener('click', prevButton._ntsClickHandler);
    }

    if (nextButton) {
      nextButton._ntsClickHandler = function () {
        scrollByCard(1);
      };
      nextButton.addEventListener('click', nextButton._ntsClickHandler);
    }

    root._ntsScrollHandler = function () {
      window.requestAnimationFrame(updateArrows);
    };

    viewport.addEventListener('scroll', root._ntsScrollHandler, { passive: true });

    if (root._ntsResizeHandler) {
      window.removeEventListener('resize', root._ntsResizeHandler);
    }

    root._ntsResizeHandler = function () {
      updateArrows();
    };

    window.addEventListener('resize', root._ntsResizeHandler);
    updateArrows();

    if (window.EvryFpg) {
      window.EvryFpg.initRoot(root);
    }
  }

  function initAllNowTrendingSliders(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = context.querySelectorAll('.now-trending-slider');

    if (scope && scope.matches && scope.matches('.now-trending-slider')) {
      initNowTrendingSlider(scope);
      return;
    }

    roots.forEach(initNowTrendingSlider);
  }

  window.EvryNowTrendingSlider = {
    refresh: initAllNowTrendingSliders,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllNowTrendingSliders();
    });
  } else {
    initAllNowTrendingSliders();
  }
})();
